import { Link } from "react-router-dom";

export default function ArticleCTA() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-accent-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-5 whitespace-nowrap">
          <i className="ri-article-line"></i>
          In-Depth Guide
        </div>
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
          Sugargoo Spreadsheet Complete Guide 2026
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          Read our comprehensive guide covering everything you need to know about Sugargoo Spreadsheet &mdash; from getting started to advanced shopping strategies. Original research, updated for 2026.
        </p>
        <Link
          to="/sugargoo-spreadsheet-complete-guide"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          Read the Complete Guide
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}